import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useCurrentUser } from "../../../../reducers/layoutReducer/selectors";

const getMlsListingDetails = (blossorId) =>
  caseTransformingAxios.get("/listings_api", { params: { blossorId } });

const getSignInSheetUrls = ({ blossorData, openHouse, userUuid, displayAgentUuid, qrCodeUrl }) =>
  caseTransformingAxios.put("/api/v4/reporting/open_house_dashboard/sign_in_sheet", {
    qrCodeUrl,
    ...(blossorData && { blueroofMlsId: blossorData.blueroofMlsId, mlsNum: blossorData.mlsNum }),
    ...(!blossorData && {
      address: openHouse.address.streetAddress,
    }),
    userUuid,
    displayAgentUuid,
  });

const getOpenHouseUrlParams = (openHouse, currentUser, userMeta) => {
  const urlParams = new URLSearchParams();
  urlParams.append("id", openHouse.checkInKey);
  urlParams.append("team", currentUser.account.teamName);
  urlParams.append("phone", userMeta.managedPhoneNumber);
  return urlParams;
};

const useSignInSheet = (openHouse, userMeta) => {
  const currentUser = useCurrentUser();
  const openhouseUrl = useSelector((state) => state.reports.openhouseUrl);
  const [loading, setLoading] = useState(false);

  const getSignInSheet = async (type) => {
    setLoading(type);

    const blossorData = await getMlsListingDetails(openHouse.propertyId)
      .then((res) => res.data)
      .catch(() => null);

    const signInData = await getSignInSheetUrls({
      blossorData,
      openHouse,
      userUuid: currentUser.uuid,
      displayAgentUuid: userMeta.userUuid,
      qrCodeUrl: `${openhouseUrl}?${getOpenHouseUrlParams(openHouse, currentUser, userMeta)}`,
    })
      .then((res) => res.data)
      .catch(() => null);

    setLoading(false);

    return signInData || { error: "Something went wrong." };
  };

  const getOpenHouseUrl = () => {
    const urlParams = getOpenHouseUrlParams(openHouse, currentUser, userMeta);
    return `${openhouseUrl}?${urlParams}`;
  };

  return { loading, getSignInSheet, getOpenHouseUrl };
};

export default useSignInSheet;
